import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import { useParams } from "react-router-dom";
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import Collapse from '@material-ui/core/Collapse';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import moment from 'moment';
import { useHistory } from "react-router-dom";
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import { useTheme } from "@mui/material/styles";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import AppBar from '@mui/material/AppBar';
import Box from '@material-ui/core/Box';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Skeleton from '@material-ui/lab/Skeleton';
import IconButton from '@material-ui/core/IconButton';

import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import api from '../../../../../../services/api';
import NavegadorGestao from "../../../../../../components/NavBarGestao";

import OrdemCompraComponente from "../../../../../../pages/painelAdmin/AreaGestao/ModuloAdministracao/OrdensDeCompras/ordemCompraComponente";

import { Button, MenuItem, Select, InputLabel } from "@material-ui/core";
import Pagination from '@material-ui/lab/Pagination';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { styled } from '@material-ui/styles';


import {
    DataGrid, 
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';

const drawerWidth = 240;


const ColorButtonBlue = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'blue',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'blue',
        color: 'whit',
        borderColor: 'blue',
    },
}));


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& .cabecalho_transparente': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: 'rgba(0, 0, 0, 0)',
        },
        '& .cabecalho_azul': {
            backgroundColor: 'rgba(0, 0, 255, 1)',
            color: 'white',
        },
        '& .cabecalho_verde': {
            backgroundColor: 'rgba(0, 100, 0, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_claro': {
            backgroundColor: 'rgba(107,142,35, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_claro': {
            backgroundColor: 'rgba(184,134,11, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_cyan': {
            backgroundColor: 'rgba(0,139,139, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_dark_sea': {
            backgroundColor: 'rgba(60,179,113, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_escuro': {
            backgroundColor: 'rgba(139,69,19, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_chocolate': {
            backgroundColor: 'rgba(210,105,30, 1)',
            color: 'white',
        },
        '& .cabecalho_darkslate': {
            backgroundColor: 'rgba(47,79,79, 1)',
            color: 'white',
        },
        '& .super-app.negative': {
            backgroundColor: 'rgba(157, 255, 118, 0.49)',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.positive': {
            backgroundColor: '#d47483',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.neutro': {
            backgroundColor: '#363636',
            color: 'white',
            fontWeight: '600',
        },
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    table: {
        minWidth: 650,
    },
}));

const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'blue',
        borderColor: 'blue',
    },
}));


const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'blue',
    },
}));




export default function GerenciarCliente() {


    const history = useHistory();


    const [tipoFisica, setTipoFisica] = useState(true);
    const [tipoJuridica, setTipoJuridica] = useState(false);

    /* variaveis pessoa fisica */
    const [cpf, setCpf] = useState('');
    const [rg, setRg] = useState('');
    const [nome, setNome] = useState('');
    const [sobreNome, setSobrenome] = useState('');
    const [dataNascimento, setDataNascimento] = useState('');
    /* variaveis pessoa fisica */

    const [contato, setContato] = useState('');

    /* variaveis de estado de cadastro de pessoa juridica*/
    const [razaoSocial, setRazaoSocial] = useState('');
    const [nomeFantasia, setNomeFantasia] = useState('');
    const [cnpj, setCnpj] = useState('');
    /* variaveis de estado de cadastro de pessoa juridica*/


    /*variaveis gerais*/
    const [porte, setPorte] = useState('');
    const [atividade, setAtividade] = useState('');
    const [ie, setIe] = useState('');
    const [descricao, setDescricao] = useState('');
    const [email, setEmail] = useState('');
    /*variaveis gerais*/

    const [parametrosEndereco, setParametrosEndereco] = useState(
        {
            logradouro: "",
            numero: "",
            bairro: "",
            complemento: "",
            cidade: "",
            estado: "",
            cep: "",
            latitude: "",
            longitude: "",
        }
    );


    /*variaveis de controle pessoa fisica */

    const [erroNome, setErroNome] = useState(false);
    const [textoErroNome, setTextoErroNome] = useState('');

    const [erroSobreNome, setErroSobreNome] = useState(false);
    const [textoErroSobreNome, setTextoErroSobreNome] = useState('');




    /*variaveis de controle pessoa fisica */


    /*variaveis de controle pessoa juridica */
    const [erroRazaoSocial, setErroRazaoSocial] = useState(false);
    const [textoErroRazaoSocial, setTextoErroRazaoSocial] = useState('');

    const [erroNomeFantasia, setErroNomeFantasia] = useState(false);
    const [textoErroNomeFantasia, setTextoErroNomeFantasia] = useState('');

    /*variaveis de controle pessoa juridica */



    /* variaveis  de controle gerais */

    /* variaveis  de controle gerais */





    const [tipoLoja, setTipoLoja] = useState(0);


    const handleTipoLoja = (event) => {
        setTipoLoja(event.target.value);
    };

    const [recebeOrdens, setRecebeOrdens] = useState(0);


    const handleRecebeOrdens = (event) => {
        setRecebeOrdens(event.target.value);
    };


    const [site, setSite] = useState('');

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md")); // mobile/tablet até md
    const [darkMode, setDarkMode] = useState(isMobile || Cookies.get('darkMode') === 'true');

    const themeTabela = createTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            ...(darkMode && {
                background: {
                    default: '#121212',
                    paper: '#1e1e1e',
                },
            }),
        },
        components: {
            MuiTablePagination: {
                styleOverrides: {
                    root: {
                        color: darkMode ? '#fff' : '#000',
                    },
                    selectLabel: {
                        color: darkMode ? '#fff' : '#000',
                    },
                    displayedRows: {
                        color: darkMode ? '#fff' : '#000',
                    },
                },
            },
            MuiSelect: {
                styleOverrides: {
                    icon: {
                        color: darkMode ? '#fff' : '#000',
                    },
                    select: {
                        color: darkMode ? '#fff' : '#000',
                    },
                },
            },
        },
    });

    useEffect(() => {
        const handleDarkModeChange = () => {
            const isDark = isMobile || Cookies.get('darkMode') === 'true'; // Force dark on mobile
            setDarkMode(isDark);
        };

        window.addEventListener('darkModeChanged', handleDarkModeChange);

        // Inicializa estado
        const currentDarkMode = isMobile || Cookies.get('darkMode') === 'true'; // Force dark on mobile
        setDarkMode(currentDarkMode);

        return () => {
            window.removeEventListener('darkModeChanged', handleDarkModeChange);
        };
    }, [isMobile]);

    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [objetoGerenciado, setObjetoGerenciado] = useState([]);

    const { idFornecedor } = useParams();


    const [height, setHeight] = useState(0);


    function checkDimenssoes() {

        var altura = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;


        setHeight(altura * 0.75);

    }

    window.addEventListener('resize', function (event) {
        checkDimenssoes();
    });




    const [contatos, setContatos] = useState([]);

    const [contasBancarias, setContasBancarias] = useState([]);

    const [nomeAmigavel, setNomeAmigavel] = useState('');



    async function listarInformacoes() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("/v1/protected/fornecedores/retornardadosfornecedor/" + idFornecedor, {
                headers: headers
            }).then(function (response) {
                setObjetoGerenciado(response.data);

                if (response.data.tipo_fornecedor === 0) {
                    setTipoFisica(true);
                    setTipoJuridica(false);
                    setNomeAmigavel(response.data.nome + " " + response.data.sobrenome);
                } else {
                    setTipoFisica(false);
                    setTipoJuridica(true);
                    setNomeAmigavel(response.data.razao_social ? response.data.razao_social : response.data.nome_fantasia);
                }


                setCpf(response.data.cpf);
                setContatos(response.data.contatos);
                setRg(response.data.rg);
                setNome(response.data.nome);
                setSobrenome(response.data.sobrenome);
                setDataNascimento(response.data.nascimento);

                setContato(response.data.contato);
                setContasBancarias(response.data.contas_bancarias)

                // Atribuindo valores da resposta à pessoa jurídica
                setRazaoSocial(response.data.razao_social);
                setNomeFantasia(response.data.nome_fantasia);
                setCnpj(response.data.cnpj);

                // Atribuindo valores gerais
                setPorte(response.data.porte);
                setAtividade(response.data.atividade);
                setIe(response.data.ie);
                setDescricao(response.data.descricao);
                setEmail(response.data.email);

                setParametrosEndereco(prevState => ({
                    ...prevState,
                    'logradouro': response.data.logradouro,
                    'numero': response.data.numero,
                    'bairro': response.data.bairro,
                    'cidade': response.data.cidade,
                    'estado': response.data.estado,
                    'cep': response.data.cep,
                    'latitude': response.data.latitude,
                    'longitude': response.data.longitude
                }));


                setSite(response.data.site);

                setRecebeOrdens(response.data.recebe_ordens);

                setTipoLoja(response.data.tipo_loja);


                setLoading(false);
            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }






    useEffect(() => {
        checkDimenssoes();
        listarInformacoes();


    }, []);






    function validarRazaoSocial() {
        if (razaoSocial?.length > 0) {
            setErroRazaoSocial(false);
            setTextoErroRazaoSocial('');
            return true;
        } else {
            setErroRazaoSocial(true);
            setTextoErroRazaoSocial("Razão Social Inválida");
            return false;
        }
    }

    function validarNomeFantasia() {
        if (nomeFantasia?.length > 0) {
            setErroNomeFantasia(false);
            setTextoErroNomeFantasia('');
            return true;
        } else {
            setErroNomeFantasia(true);
            setTextoErroNomeFantasia("Nome Fantasia Inválido");
            return false;
        }
    }

    function validarNome() {
        if (nome?.length > 0) {
            setErroNome(false);
            setTextoErroNome('');
            return true;
        } else {
            setErroNome(true);
            setTextoErroNome("Nome muito curto");
            return false;
        }
    }





    function validarSobreNome() {
        if (sobreNome?.length > 0) {
            setErroSobreNome(false);
            setTextoErroSobreNome('');
            return true;
        } else {
            setErroSobreNome(true);
            setTextoErroSobreNome("Sobrenome muito curto");
            return false;
        }
    }



    async function atualizar() {

        if (tipoFisica) {
            //cadastrar pessoa fisica

            validarNome();
            validarSobreNome();

            //prosseguir cadastro
            if (validarNome() &&
                validarSobreNome()) {
                console.log("cadastro aceito!")

                try {
                    const cadastro_cliente_pf = {
                        tipo_fornecedor: 0,
                        nome: nome,
                        sobrenome: sobreNome,
                        nascimento: dataNascimento,
                        rg: rg,
                        descricao: descricao,
                        logradouro: parametrosEndereco.logradouro,
                        numero: parametrosEndereco.numero,
                        bairro: parametrosEndereco.bairro,
                        cidade: parametrosEndereco.cidade,
                        estado: parametrosEndereco.estado,
                        cep: parametrosEndereco.cep,
                        latitude: parametrosEndereco.latitude,
                        longitude: parametrosEndereco.longitude,
                        site: site,
                        contato: contato,
                        tipo_loja: tipoLoja,
                        recebe_ordens: recebeOrdens,
                    }

                    const headers = {
                        'Authorization': 'Bearer ' + Cookies.get("token")
                    }

                    const response = await api.put('/v1/protected/fornecedores/atualizar/' + idFornecedor, cadastro_cliente_pf,
                        { headers: headers });

                    const cadastro_salvo = response.data;
                    if (cadastro_salvo) {
                        alert("Fornecedor atualizado com sucesso!")

                        window.location.reload();

                    } else {
                        alert("Erro de Conexão, tente novamente mais tarde");
                    }
                } catch (_err) {
                    console.log("erro ao cadastrar: " + _err);
                    alert("Erro de Conexão, tente novamente mais tarde");

                }



            } else {
                console.log("cadastro rejeitado!")
            }



        } else {
            //cadastrar pessoa juridica

            validarRazaoSocial();
            validarNomeFantasia();


            //prosseguir cadastro
            if (validarRazaoSocial() && validarNomeFantasia) {
                console.log("cadastro pj aceito!")

                try {

                    console.log("cadastrar chamado");
                    const cadastro_cliente_pj = {
                        tipo_fornecedor: 1,
                        razao_social: razaoSocial,
                        nome_fantasia: nomeFantasia,
                        porte: porte,
                        atividade: atividade,
                        descricao: descricao,
                        logradouro: parametrosEndereco.logradouro,
                        numero: parametrosEndereco.numero,
                        bairro: parametrosEndereco.bairro,
                        cidade: parametrosEndereco.cidade,
                        estado: parametrosEndereco.estado,
                        cep: parametrosEndereco.cep,
                        latitude: parametrosEndereco.latitude,
                        longitude: parametrosEndereco.longitude,
                        site: site,
                        contato: contato,
                        tipo_loja: tipoLoja,
                        recebe_ordens: recebeOrdens,
                    }

                    const headers = {
                        'Authorization': 'Bearer ' + Cookies.get("token")
                    }

                    const response = await api.put('/v1/protected/fornecedores/atualizar/' + idFornecedor, cadastro_cliente_pj,
                        { headers: headers });

                    const cadastro_salvo = response.data;
                    if (cadastro_salvo) {
                        alert("Fornecedor atualizado com sucesso!")
                        window.location.reload();

                    } else {
                        alert("Erro de Conexão, tente novamente mais tarde");
                    }
                } catch (_err) {
                    console.log("erro ao cadastrar: " + _err);
                    alert("Erro de Conexão, tente novamente mais tarde");

                }



            } else {
                console.log("cadastro pj rejeitado!")
            }

        }
    }




    const handleChange1 = (event) => {
        setTipoFisica(true);
        setTipoJuridica(false);
    };

    const handleChange2 = (event) => {
        setTipoFisica(false);
        setTipoJuridica(true);
    };



    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);

    }


    const handleChangeIndex = (index) => {
        setValue(index);
    };


    function novoContato() {
        window.location.href = "/gestao/operacional/almoxarifado/fornecedores/gerenciarfornecedor/" + idFornecedor + "/cadastrarcontato"

    }


    function novaConta() {
        window.location.href = "/gestao/operacional/almoxarifado/fornecedores/gerenciarfornecedor/" + idFornecedor + "/cadastrarcontabancaria"

    }



    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }



    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick = (param, event) => {
        event.stopPropagation();
    };



    const handleClickEdicao = (event, cellValues) => {


        window.location.href = "/gestao/operacional/almoxarifado/fornecedores/gerenciarfornecedor/" + idFornecedor + "/editarcontato/" + cellValues.row.id_contato;


    };


    const columnsContatosDataGrid = [
        {
            field: 'acoes',
            headerName: 'Ações',
            headerClassName: 'cabecalho_marrom_claro',
            sortable: false,
            width: 200,
            renderCell: (cellValues) => {
                return (
                    <ColorButtonGreen variant="contained" color="primary"
                        onClick={(event) => handleClickEdicao(event, cellValues)}
                    >
                        Editar
                    </ColorButtonGreen>
                )
            },
        },


        {
            headerName: 'ID',
            field: 'id_contato',
            id: 1,
            headerClassName: 'cabecalho_azul',
        },


        {
            headerName: 'Nome',
            field: 'nome_contato',
            id: 2,
            width: 300,
            headerClassName: 'cabecalho_azul',

        },

        {
            headerName: 'Cargo',
            field: 'cargo_contato',
            id: 3,
            width: 300,
            headerClassName: 'cabecalho_azul',

        },
        {
            headerName: 'Celular',
            field: 'celular_contato',
            id: 4,
            width: 300,
            headerClassName: 'cabecalho_azul',

        },

        {
            headerName: 'Fixo',
            field: 'fixo_contato',
            id: 5,
            width: 300,
            headerClassName: 'cabecalho_azul',

        },

        {
            headerName: 'E-mail',
            field: 'e_mail_contato',
            id: 6,
            width: 300,
            headerClassName: 'cabecalho_azul',

        },
        {
            headerName: 'Envio de E-mail',
            field: 'emails',
            id: 7,
            width: 600,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                var email_principal = cellValues.row.email_principal;
                var email_copia = cellValues.row.email_copia;


                return (
                    <Typography style={{ fontSize: 16 }} variant="h6">
                        {email_principal === 1 ? "É destinátario de e-mail" : email_copia === 1 ? "É destinátario em Cópia" : "Não"}
                    </Typography>
                )
            },
        },
        {
            headerName: 'Descrição',
            field: 'descricao_contato',
            id: 7,
            width: 600,
            headerClassName: 'cabecalho_azul',

        },




    ];




    const columnsContasDataGrid = [

        {
            headerName: 'ID',
            field: 'id_conta_bancaria',
            id: 1,
            headerClassName: 'cabecalho_azul',
            width: 50,

        },
        {
            headerName: 'CPF/CNPJ',
            field: 'identificacao',
            id: 2,
            width: 100,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'Titular',
            field: 'titular',
            id: 3,
            width: 200,
            headerClassName: 'cabecalho_azul',
        },

        {
            headerName: 'Descrição',
            field: 'descricao',
            id: 4,
            width: 100,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'Banco',
            field: 'banco',
            id: 5,
            width: 100,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'Agência',
            field: 'agencia',
            id: 6,
            width: 100,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'Conta',
            field: 'conta',
            id: 7,
            width: 100,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'PIX',
            field: 'chave_1',
            id: 8,
            width: 200,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const tipo = cellValues.row?.tipo_chave_1 || "";
                const chave = cellValues.row?.chave_1 || "";

                return (
                    <Typography variant="body2" style={{ fontSize: 14 }}>
                        {tipo
                            ? (<><strong>{tipo}</strong>: {chave}</>)
                            : chave
                        }
                    </Typography>
                );
            }
        },
    ];




    return (
        <div>

            <NavegadorGestao
                Almoxarifado={true}
                Fornecedores={true}
                corFundo={darkMode ? '#252525' : 'white'} travado={true} corTexto={darkMode ? 'white' : 'black'}
            />



            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                align="flex-start"
                item xs={12}
                style={{ width: '100%', margin: 0, padding: 0 }}
            >


                <a href="/gestao/operacional/almoxarifado/fornecedores/listar/1" style={{ fontSize: 14, color: darkMode ? 'white' : 'black', marginRight: '5px' }}>{"< Fornecedores"}</a>

                <a
                    href={"/gestao/operacional/almoxarifado/fornecedores/gerenciarfornecedor/" + idFornecedor}
                    style={{ fontSize: 14, color: darkMode ? 'white' : 'black', marginRight: '5px' }}
                >
                    {" | " + nomeAmigavel}

                </a>
            </Grid>



            <div style={{ paddingTop: 5 }}>
                {loading ?
                    <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                    </Skeleton>
                    :

                    <React.Fragment >

                        <Grid
                            item xs={12}
                            container
                            direction="row"
                            alignItems="center"
                            justifyContent={"center"}
                        >


                            <Grid
                                item xs={12}
                                container
                                direction="row"
                                alignItems="center"
                                justifyContent={"center"}
                            >


                                <Box style={{ backgroundColor: darkMode ? '#121212' : 'white', width: '100%', alignItems: 'center', }}>
                                    <AppBar position="static" >

                                        <Tabs
                                            value={value}
                                            onChange={handleChange}
                                            indicatorColor="secondary"
                                            textColor="inherit"
                                            variant="scrollable"
                                            scrollButtons="auto"
                                            aria-label="scrollable auto tabs example"

                                        >
                                            <Tab label="Especificações" style={{ backgroundColor: '#1C1C1C' }} />
                                            <Tab label="Contatos" style={{ backgroundColor: 'blue' }} />
                                            <Tab label="Contas Bancárias" style={{ backgroundColor: 'green' }} />
                                            <Tab label="Ordens de Compras" style={{ backgroundColor: 'brown' }} />

                                        </Tabs>
                                    </AppBar>

                                </Box>
                            </Grid>

                            <Grid
                                item xs={12}
                                container
                                direction="row"
                                alignItems="center"
                                justifyContent={"center"}
                            >

                                <SwipeableViews
                                    index={value}
                                    onChangeIndex={handleChangeIndex}
                                    style={{ backgroundColor: darkMode ? '#121212' : 'white', width: '100%', alignItems: 'center', }}
                                >
                                    <Grid value={value} index={0}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        style={{ backgroundColor: darkMode ? '#121212' : 'white', width: '100%', alignItems: 'center', }}
                                    >

                                        <Grid
                                            item xs={12}
                                            alignItems="center"
                                            justifyContent="center"
                                            style={{ padding: 15 }}
                                            container  >




                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="center"
                                                alignItems="center"
                                                item xs={12}
                                            >
                                                <Typography style={{ color: darkMode ? 'white' : 'black' }}  >
                                                    Tipo Pessoa:
                                                </Typography>
                                                <FormControlLabel style={{ paddingLeft: 10, color: darkMode ? 'white' : 'black' }} control={<Checkbox checked={tipoFisica}
                                                    onChange={handleChange1} style={{ color: darkMode ? 'white' : undefined }} />} label="Pessoa Física" />
                                                <FormControlLabel style={{ color: darkMode ? 'white' : 'black' }} control={<Checkbox checked={tipoJuridica}
                                                    onChange={handleChange2} style={{ color: darkMode ? 'white' : undefined }} />} label="Pessoa Jurídica" />


                                            </Grid>


                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="center"
                                                alignItems="center"
                                                item xs={12}
                                            >
                                                <Typography style={{ paddingRight: 10, color: darkMode ? 'white' : 'black' }} >
                                                    Tipo Loja:
                                                </Typography>
                                                <Select
                                                    value={tipoLoja}
                                                    onChange={handleTipoLoja}
                                                    label="Local"
                                                    style={{ color: darkMode ? 'white' : 'black' }}
                                                >
                                                    <MenuItem value={0}>Local</MenuItem>
                                                    <MenuItem value={1}>Online</MenuItem>
                                                </Select>

                                            </Grid>

                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="center"
                                                alignItems="center"
                                                item xs={12}
                                                style={{ paddingBottom: 50, paddingTop: 20 }}
                                                spacing={5}>

                                                <Typography style={{ paddingRight: 10, color: darkMode ? 'white' : 'black' }}>
                                                    Recebe Ordens de Compra:
                                                </Typography>
                                                <RadioGroup
                                                    value={recebeOrdens}
                                                    onChange={handleRecebeOrdens}
                                                    row
                                                >
                                                    <FormControlLabel
                                                        value="0"
                                                        control={<Radio />}
                                                        label="Não"
                                                        style={{ color: darkMode ? 'white' : 'black' }}
                                                    />
                                                    <FormControlLabel
                                                        value="1"
                                                        control={<Radio />}
                                                        label="Sim"
                                                        style={{ color: darkMode ? 'white' : 'black' }}
                                                    />
                                                </RadioGroup>
                                            </Grid>



                                            <Collapse style={{ width: '100%' }} in={tipoJuridica} timeout="auto" unmountOnExit>
                                                <Grid
                                                    container
                                                    direction="row"
                                                    item xs={12}
                                                    spacing={2}>

                                                    <Grid item xs={4}>
                                                        <TextField

                                                            variant="standard"
                                                            name="cnpj"
                                                            label="CNPJ"
                                                            required
                                                            id="cnpj"
                                                            value={cnpj}
                                                            inputProps={{
                                                                maxLength: 14,
                                                                minLength: 14,
                                                                style: { color: darkMode ? 'white' : 'black' }
                                                            }}
                                                            InputLabelProps={{
                                                                style: { color: darkMode ? 'white' : 'black' }
                                                            }}
                                                            fullWidth
                                                        />
                                                    </Grid>

                                                    <Grid item xs={4} >
                                                        <TextField
                                                            error={erroRazaoSocial}
                                                            helperText={textoErroRazaoSocial}
                                                            variant="standard"
                                                            name="razaoSocial"
                                                            label="Razão Social"
                                                            required
                                                            id="razaoSocial"
                                                            autoComplete="razaoSocial"
                                                            value={razaoSocial}
                                                            onChange={e => setRazaoSocial(e.target.value)}
                                                            inputProps={{
                                                                maxLength: 50,
                                                                minLength: 1,
                                                                style: { color: darkMode ? 'white' : 'black' }
                                                            }}
                                                            InputLabelProps={{
                                                                style: { color: darkMode ? 'white' : 'black' }
                                                            }}
                                                            fullWidth

                                                        />
                                                    </Grid>

                                                    <Grid item xs={4} >
                                                        <TextField
                                                            error={erroNomeFantasia}
                                                            helperText={textoErroNomeFantasia}
                                                            variant="standard"
                                                            name="nomeFantasia"
                                                            label="Nome Fantasia"
                                                            required
                                                            id="nomeFantasia"
                                                            value={nomeFantasia}
                                                            onChange={e => setNomeFantasia(e.target.value)}
                                                            inputProps={{
                                                                maxLength: 50,
                                                                minLength: 1,
                                                                style: { color: darkMode ? 'white' : 'black' }
                                                            }}
                                                            InputLabelProps={{
                                                                style: { color: darkMode ? 'white' : 'black' }
                                                            }}
                                                            fullWidth

                                                        />
                                                    </Grid>
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        item xs={12}
                                                        spacing={2}>

                                                        <Grid item xs={4} >

                                                            <TextField

                                                                variant="standard"
                                                                name="porte"
                                                                label="Porte"
                                                                id="porte"
                                                                value={porte}
                                                                onChange={e => setPorte(e.target.value)}
                                                                inputProps={{
                                                                    maxLength: 100,
                                                                    minLength: 0,
                                                                    style: { color: darkMode ? 'white' : 'black' }
                                                                }}
                                                                InputLabelProps={{
                                                                    style: { color: darkMode ? 'white' : 'black' }
                                                                }}
                                                                fullWidth

                                                            />
                                                        </Grid>

                                                        <Grid item xs={4} >
                                                            <TextField
                                                                variant="standard"
                                                                name="atividade"
                                                                label="Atividade"
                                                                id="atividade"
                                                                autoComplete="atividade"
                                                                value={atividade}
                                                                onChange={e => setAtividade(e.target.value)}
                                                                inputProps={{
                                                                    maxLength: 100,
                                                                    minLength: 0,
                                                                    style: { color: darkMode ? 'white' : 'black' }
                                                                }}
                                                                InputLabelProps={{
                                                                    style: { color: darkMode ? 'white' : 'black' }
                                                                }}
                                                                fullWidth

                                                            />
                                                        </Grid>

                                                        <Grid item xs={4}  >
                                                            <TextField

                                                                variant="standard"
                                                                name="ie"
                                                                label="Inscrição Estadual"
                                                                id="ei"
                                                                value={ie}
                                                                onChange={e => setIe(e.target.value)}
                                                                inputProps={{
                                                                    maxLength: 20,
                                                                    minLength: 0,
                                                                    style: { color: darkMode ? 'white' : 'black' }
                                                                }}
                                                                InputLabelProps={{
                                                                    style: { color: darkMode ? 'white' : 'black' }
                                                                }}
                                                                fullWidth

                                                            />
                                                        </Grid>


                                                    </Grid>
                                                </Grid>
                                            </Collapse>

                                            <Collapse style={{ width: '100%' }} in={tipoFisica} timeout="auto" unmountOnExit>
                                                <Grid
                                                    container
                                                    direction="row"
                                                    item xs={12}
                                                    spacing={2}>
                                                    <Grid item xs={4}  >

                                                        <TextField

                                                            variant="standard"
                                                            name="cpf"
                                                            label="CPF"
                                                            required
                                                            id="cpf"
                                                            value={cpf}
                                                            inputProps={{
                                                                maxLength: 11,
                                                                minLength: 11,
                                                                style: { color: darkMode ? 'white' : 'black' }
                                                            }}
                                                            InputLabelProps={{
                                                                style: { color: darkMode ? 'white' : 'black' }
                                                            }}
                                                            fullWidth

                                                        />
                                                    </Grid>

                                                    <Grid item xs={4}  >
                                                        <TextField
                                                            variant="standard"
                                                            name="rg"
                                                            label="RG"
                                                            required
                                                            id="rg"
                                                            value={rg}
                                                            onChange={e => setRg(e.target.value)}
                                                            inputProps={{
                                                                maxLength: 20,
                                                                minLength: 3,
                                                                style: { color: darkMode ? 'white' : 'black' }
                                                            }}
                                                            InputLabelProps={{
                                                                style: { color: darkMode ? 'white' : 'black' }
                                                            }}
                                                            fullWidth

                                                        />
                                                    </Grid>


                                                    <Grid item xs={4}  >
                                                        <TextField
                                                            variant="standard"
                                                            name="dataNascimento"
                                                            label="Data Nascimento"
                                                            required
                                                            id="dataNascimento"
                                                            value={dataNascimento}
                                                            onChange={e => setDataNascimento(e.target.value)}
                                                            inputProps={{
                                                                maxLength: 20,
                                                                minLength: 3,
                                                                style: { color: darkMode ? 'white' : 'black' }
                                                            }}
                                                            InputLabelProps={{
                                                                style: { color: darkMode ? 'white' : 'black' }
                                                            }}
                                                            fullWidth

                                                        />
                                                    </Grid>

                                                    <Grid item xs={4}  >
                                                        <TextField
                                                            error={erroNome}
                                                            helperText={textoErroNome}
                                                            variant="standard"
                                                            name="nome"
                                                            label="Nome"
                                                            required
                                                            id="nome"
                                                            value={nome}
                                                            onChange={e => setNome(e.target.value)}
                                                            inputProps={{
                                                                maxLength: 100,
                                                                minLength: 2,
                                                                style: { color: darkMode ? 'white' : 'black' }
                                                            }}
                                                            InputLabelProps={{
                                                                style: { color: darkMode ? 'white' : 'black' }
                                                            }}
                                                            fullWidth

                                                        />
                                                    </Grid>

                                                    <Grid item xs={4}  >
                                                        <TextField
                                                            error={erroSobreNome}
                                                            helperText={textoErroSobreNome}
                                                            variant="standard"
                                                            name="sobrenome"
                                                            label="Sobrenome"
                                                            required
                                                            id="sobrenome"
                                                            value={sobreNome}
                                                            onChange={e => setSobrenome(e.target.value)}
                                                            inputProps={{
                                                                maxLength: 100,
                                                                minLength: 2,
                                                                style: { color: darkMode ? 'white' : 'black' }
                                                            }}
                                                            InputLabelProps={{
                                                                style: { color: darkMode ? 'white' : 'black' }
                                                            }}
                                                            fullWidth

                                                        />
                                                    </Grid>

                                                </Grid>
                                            </Collapse>





                                            <Grid
                                                container
                                                direction="row"
                                                item xs={12}
                                                style={{ paddingTop: 15 }}
                                                spacing={2}>

                                                <Grid item xs={8} >
                                                    <TextField
                                                        variant="standard"
                                                        name="descricao"
                                                        label="Descrição"
                                                        id="descricao"
                                                        value={descricao}
                                                        onChange={e => setDescricao(e.target.value)}
                                                        inputProps={{
                                                            style: { color: darkMode ? 'white' : 'black', backgroundColor: 'transparent' }
                                                        }}
                                                        InputLabelProps={{
                                                            style: { color: darkMode ? 'white' : 'black' }
                                                        }}
                                                        fullWidth
                                                        multiline
                                                        rows={4}

                                                    />
                                                </Grid>
                                            </Grid>



                                            <Grid
                                                container
                                                direction="row"
                                                item xs={12}
                                                spacing={2}>

                                                <Grid item xs={8} >
                                                    <TextField
                                                        variant="standard"
                                                        name="contato"
                                                        label="Contato"
                                                        id="contato"
                                                        value={contato}
                                                        onChange={e => setContato(e.target.value)}
                                                        inputProps={{
                                                            style: { color: darkMode ? 'white' : 'black', backgroundColor: 'transparent' }
                                                        }}
                                                        InputLabelProps={{
                                                            style: { color: darkMode ? 'white' : 'black' }
                                                        }}
                                                        fullWidth
                                                        multiline
                                                        minRows={1}

                                                    />
                                                </Grid>
                                            </Grid>






                                            <Grid
                                                container
                                                direction="row"
                                                item xs={12}
                                                alignItems="center"
                                                justifyItems="center"
                                                style={{ paddingTop: 80 }}
                                            >
                                                <Grid style={{ backgroundColor: darkMode ? '#1e1e1e' : 'whitesmoke', padding: 20, color: darkMode ? 'white' : 'black' }} component={Paper} elevation={12}
                                                    container
                                                    direction="row"
                                                    item xs={12}
                                                    alignItems="center"
                                                >
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        item xs={12}
                                                    >
                                                        <Grid
                                                            container
                                                            direction="row" spacing={2}
                                                            item xs={12}>

                                                            <Typography style={{ margin: 15, color: darkMode ? 'white' : 'black' }} >
                                                                <span style={{ fontSize: 22, textDecoration: 'underline' }}>Dados de Endereço: </span>
                                                            </Typography>


                                                            <Grid item xs={12}>
                                                                <TextField

                                                                    id="logradouro"
                                                                    variant="standard"
                                                                    name="logradouro"
                                                                    fullWidth
                                                                    label="Logradouro"
                                                                    value={parametrosEndereco.logradouro}
                                                                    onChange={e => setParametrosEndereco(prevState => ({ ...prevState, 'logradouro': e.target.value }))}
                                                                    inputProps={{
                                                                        maxLength: 40,
                                                                        minLength: 6,
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={2}>
                                                                <TextField

                                                                    id="numero"
                                                                    variant="standard"
                                                                    name="numero"
                                                                    fullWidth
                                                                    label="Número"
                                                                    value={parametrosEndereco.numero}
                                                                    onChange={e => setParametrosEndereco(prevState => ({ ...prevState, 'numero': e.target.value }))}
                                                                    inputProps={{
                                                                        maxLength: 40,
                                                                        minLength: 6,
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={5}>
                                                                <TextField

                                                                    id="bairro"
                                                                    variant="standard"
                                                                    name="bairro"
                                                                    fullWidth
                                                                    label="Bairro"
                                                                    value={parametrosEndereco.bairro}
                                                                    onChange={e => setParametrosEndereco(prevState => ({ ...prevState, 'bairro': e.target.value }))}
                                                                    inputProps={{
                                                                        maxLength: 40,
                                                                        minLength: 6,
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                />
                                                            </Grid>



                                                            <Grid item xs={5}>
                                                                <TextField

                                                                    id="complemento"
                                                                    variant="standard"
                                                                    name="complemento"
                                                                    fullWidth
                                                                    label="Complemento"
                                                                    value={parametrosEndereco.complemento}
                                                                    onChange={e => setParametrosEndereco(prevState => ({ ...prevState, 'complemento': e.target.value }))}
                                                                    inputProps={{
                                                                        maxLength: 40,
                                                                        minLength: 6,
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                <TextField

                                                                    id="cidade"
                                                                    variant="standard"
                                                                    name="cidade"
                                                                    fullWidth
                                                                    label="Cidade"
                                                                    value={parametrosEndereco.cidade}
                                                                    onChange={e => setParametrosEndereco(prevState => ({ ...prevState, 'cidade': e.target.value }))}
                                                                    inputProps={{
                                                                        maxLength: 40,
                                                                        minLength: 6,
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                <TextField

                                                                    id="estado"
                                                                    variant="standard"
                                                                    name="estado"
                                                                    fullWidth
                                                                    label="Estado"
                                                                    value={parametrosEndereco.estado}
                                                                    onChange={e => setParametrosEndereco(prevState => ({ ...prevState, 'estado': e.target.value }))}
                                                                    inputProps={{
                                                                        maxLength: 40,
                                                                        minLength: 6,
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                <TextField

                                                                    id="cep"
                                                                    variant="standard"
                                                                    name="cep"
                                                                    fullWidth
                                                                    label="CEP"
                                                                    value={parametrosEndereco.cep}
                                                                    onChange={e => setParametrosEndereco(prevState => ({ ...prevState, 'cep': e.target.value }))}
                                                                    inputProps={{
                                                                        maxLength: 40,
                                                                        minLength: 6,
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                />
                                                            </Grid>


                                                            <Grid item xs={4}>
                                                                <TextField

                                                                    id="latitude"
                                                                    variant="standard"
                                                                    name="latitude"
                                                                    fullWidth
                                                                    label="Latitude"
                                                                    value={parametrosEndereco.latitude}
                                                                    onChange={e => setParametrosEndereco(prevState => ({ ...prevState, 'latitude': e.target.value }))}
                                                                    inputProps={{
                                                                        maxLength: 40,
                                                                        minLength: 6,
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                <TextField

                                                                    id="longitude"
                                                                    variant="standard"
                                                                    name="longitude"
                                                                    fullWidth
                                                                    label="Longitude"
                                                                    value={parametrosEndereco.longitude}
                                                                    onChange={e => setParametrosEndereco(prevState => ({ ...prevState, 'longitude': e.target.value }))}
                                                                    inputProps={{
                                                                        maxLength: 40,
                                                                        minLength: 6,
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        style: { color: darkMode ? 'white' : 'black' }
                                                                    }}
                                                                />
                                                            </Grid>


                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="flex-end"
                                                alignItems="center"
                                                item xs={10}
                                            >
                                                <Button style={{ marginTop: 50 }}
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={atualizar}
                                                > Atualizar  </Button>
                                            </Grid>

                                        </Grid>


                                    </Grid>

                                    <Grid value={value} index={1}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        style={{ backgroundColor: darkMode ? '#121212' : 'white', width: '100%', alignItems: 'center', }}
                                    >

                                        <ThemeProvider theme={themeTabela}>
                                            <DataGrid
                                                pagination
                                                checkboxSelection
                                                rows={contatos}
                                                getRowId={(row) => row.id_contato}
                                                columns={columnsContatosDataGrid}
                                                disableColumnResize={false}
                                                onCellClick={handleCellClick}
                                                onRowClick={handleRowClick}
                                                components={{
                                                    Toolbar: CustomToolbar,
                                                }}
                                                sx={{
                                                    '& .MuiDataGrid-cell': {
                                                        color: darkMode ? '#fff' : '#000',
                                                    },
                                                    '& .MuiDataGrid-columnHeaderTitle': {
                                                        color: '#fff', // Cabecalhos coloridos geralmente tem texto branco
                                                    },
                                                }}
                                            />
                                        </ThemeProvider>

                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="flex-end"
                                            alignItems="center"
                                            item xs={12}
                                        >
                                            <Button style={{ marginTop: 50 }}
                                                variant="contained"
                                                color="primary"
                                                onClick={novoContato}
                                            > Novo Contato  </Button>
                                        </Grid>

                                    </Grid>



                                    <Grid value={value} index={2}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        style={{ backgroundColor: darkMode ? '#121212' : 'white', width: '100%', alignItems: 'center', }}
                                    >

                                        <ThemeProvider theme={themeTabela}>
                                            <DataGrid
                                                pagination
                                                checkboxSelection
                                                rows={contasBancarias}
                                                getRowId={(row) => row.id_conta_bancaria}
                                                columns={columnsContasDataGrid}
                                                disableColumnResize={false}
                                                onCellClick={handleCellClick}
                                                onRowClick={handleRowClick}
                                                components={{
                                                    Toolbar: CustomToolbar,
                                                }}
                                                sx={{
                                                    '& .MuiDataGrid-cell': {
                                                        color: darkMode ? '#fff' : '#000',
                                                    },
                                                    '& .MuiDataGrid-columnHeaderTitle': {
                                                        color: '#fff',
                                                    },
                                                }}
                                            />
                                        </ThemeProvider>

                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="flex-end"
                                            alignItems="center"
                                            item xs={12}
                                        >
                                            <Button style={{ marginTop: 50 }}
                                                variant="contained"
                                                color="primary"
                                                onClick={novaConta}
                                            > Nova Conta Bancária  </Button>
                                        </Grid>

                                    </Grid>


                                    <Grid value={value} index={3}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        style={{ backgroundColor: darkMode ? '#121212' : 'white', width: '100%', alignItems: 'center', }}
                                    >
                                        <Box
                                            sx={{
                                                width: '100%',
                                                padding: 1,     // padding interno
                                                boxSizing: 'border-box',
                                            }}
                                        >
                                            <OrdemCompraComponente idFornecedor={idFornecedor} idProposta={0} idColaborador={0} />
                                        </Box>
                                    </Grid>



                                </SwipeableViews>
                            </Grid>
                        </Grid>




                    </React.Fragment>
                }


            </div>




        </div >
    );
}



